import FiscalDocsProviderTypeEnum from '@/api/Enums/FiscalDocsProviderTypeEnum'
import PaymentTypeEnum from '@/api/Enums/PaymentTypeEnum'
import TransactionsCommon from '@/mixins/payments/transactionsCommon.js'

export default {
  data() {
    return {}
  },
  components: {},
  mixins    : [TransactionsCommon],
  props     : {},
  directives: {},
  watch     : {},
  methods   : {
    orderTransactionsTotal(order) {
      let val = order.PaymentTransactions.reduce((a, b) => a + parseFloat(b.Amount), 0) || 0

      if (this.appFiscalDocsProviderType === FiscalDocsProviderTypeEnum.CLOUD) {
        val = order.PaymentTransactions.filter(transaction => {
          return this.eftPosCardTransactionPaidSuccessful(transaction) || (!transaction.hasOwnProperty('Paid') || transaction.PaymentType !== PaymentTypeEnum.CARD)
        }).reduce((a, b) => a + parseFloat(b.Amount), 0) || 0
      }

      return parseFloat(val.toFixed(2))
    },

    orderHasCashPaymentTransaction(order) {
      return !!order?.PaymentTransactions?.some(payment => payment.PaymentType === PaymentTypeEnum.CASH)
    },

    orderHasPaymentTypeTransaction(order, paymentType) {
      return !!order?.PaymentTransactions?.some(payment => payment.PaymentType === paymentType)
    },

    orderHasCardPaymentTransaction(order) {
      return !!order?.PaymentTransactions?.some(payment => PaymentTypeEnum.isAnyCard(payment.PaymentType))
    },

    orderHasOnlineCardPayments(order) {
      return PaymentTypeEnum.isOnlineCard(order?.Payment)
    },

    orderRefundableTransactions(order) {
      return order?.PaymentTransactions?.filter(payment => payment.Status === 'APPROVED' && payment.PaymentType === PaymentTypeEnum.CARD) || []
    },

    orderHasPaymentMethodRefundable(order) {
      return this.orderRefundableTransactions(order).length > 0
    },

    orderIsRefundable(order) {
      return this.orderHasPaymentMethodRefundable(order) || this.orderHasOnlineCardPayments(order)
    },

    orderRefundableAmount(order) {
      if (this.orderHasOnlineCardPayments(order)) return order?.Price ?? 0

      if (this.orderHasPaymentMethodRefundable(order)) return this.orderRefundableTransactions(order).reduce((a, b) => a + parseFloat(b?.Amount ?? 0), 0) || 0

      return 0
    },

    orderHasRefundableTransactions(order) {
      if (!order) return false

      return order?.PaymentMethods?.some(payment => payment.Refundable)
    },

    orderRefundableTransactionsTotal(order) {
      if (!order) return 0

      return order?.PaymentMethods?.filter(payment => payment.Refundable)?.reduce((a, b) => a + parseFloat(b.Amount), 0) || 0
    }
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }

}
